// extracted by mini-css-extract-plugin
module.exports = {"hiddenIframe":"IframeUtil_hiddenIframe__4pBMo"};